import * as T from "../constants";

const initialState = {
    firstName: "",
    middleInitial: "",
    lastName: "",
    dateOfBirth: "",
    phone: "",
    emailAddress: "",
    ssn: "",
    vin: ""
}

const infoReducer = (state = initialState, action) => {
    const { payload, type } = action;

    switch (type) {
        case T.INFO_ENTERED:
            return {
                ...state,
                ...payload
            }
        default:
            return state;
    }
}

export default infoReducer;